/**
 * ID generation.
 *
 * Berrier Reno uses UUID v4 strings as primary keys for user-created records.
 * Rationale (documented per the Phase 1 requirements):
 *  - globally unique, so a future centralized/multi-device migration
 *    (spec Section 10) cannot produce colliding IDs;
 *  - generated app-side, so records have identity before they are persisted;
 *  - never derived from display names (spec: names are not identity).
 *
 * `crypto.randomUUID` exists in both WebView2 (the Tauri webview) and Node 19+.
 */
export function generateId(): string {
  return crypto.randomUUID();
}
